import axios from 'axios';

/**
 * @typedef {object} DashStream
 * @property {string} longId
 */

export default {
    /**
     * @async
     * @param {object} fields
     * @param {string} fields.url
     * @returns {DashStream}
     */
    async createStream(fields) {
        const options = {
            method: 'POST',
            baseURL: window.apiUrl,
            url: '/dash-streams',
            data: fields,
            headers: {
                'Authorization': 'Bearer ' + localStorage.token
            }
        };
        const res = await axios.request(options);
        return { longId: res.data.longId };
    },

    /**
     * Returns a URL that can be passed to Video.js in order to play the stream.
     * @param {string} longId
     * @returns {string} url
     */
    getStreamPlaylistUrl(longId) {
        return `${window.apiUrl}/dash-streams/${longId}/playlist.mpd`;
    },
};



// WEBPACK FOOTER //
// ./src/services/dash-streams/index.js